module.exports = __webpack_public_path__ + "img/logo_bak.20a094d0.svg";